export function About() {
  return (
    <section id="about" className="section section-alt">
      <div className="section-inner">
        <h2 className="section-title">About</h2>
        <div className="about-text">
          <p>
            I'm an experienced entrepreneur and technology leader who has helped
            build multiple successful consumer internet businesses in the
            interactive media and games verticals. My work spans founding
            companies, growing products from zero to millions of users, and
            leading cross-functional teams through rapid scale.
          </p>
          <p>
            At RealNetworks, I helped define the casual games industry with
            RealArcade, one of the first app stores. At Smilebox, I co-founded
            and built a platform that redefined electronic greetings with
            personal photos, reaching 20 million downloads. With Fanzo, I
            graduated from Techstars and built a five-star mobile app. At Ripl,
            I grew a mobile marketing tool for small business owners from $0 to
            $10M ARR in 2.5 years.
          </p>
          <p>
            At Al Jazeera Media Network, I pioneered the organization's flagship
            mobile app, unifying its global news properties — Al Jazeera English,
            Arabic, Mubasher, Balkans, and China — into a single experience that
            earned the highest App Store ratings of any news app. I also
            transformed the engineering culture behind their web platforms,
            taking the team from one release every three months to three
            releases every week.
          </p>
          <p>
            Most recently, my focus has turned to building with AI. I've shipped
            voice agents, multi-agent systems, and LLM-powered products, and
            created developer tooling and infrastructure for the emerging world
            of autonomous agents. From real-time conversational AI to
            computer-vision pipelines, I design systems where language models and
            deterministic engineering work together — a selection of that work is
            below.
          </p>
          <p>
            With over 30 years of software engineering experience, my expertise
            spans technical, product, and business leadership. I solve the
            hardest problems and build systems that pass the test of time.
          </p>
        </div>
        <div className="about-highlights">
          <div className="about-highlight">
            <div className="about-highlight-number">30+</div>
            <div className="about-highlight-label">Years in Software</div>
          </div>
          <div className="about-highlight">
            <div className="about-highlight-number">$10M</div>
            <div className="about-highlight-label">ARR at Ripl</div>
          </div>
          <div className="about-highlight">
            <div className="about-highlight-number">20M+</div>
            <div className="about-highlight-label">Product Downloads</div>
          </div>
        </div>
      </div>
    </section>
  );
}
